import { render, staticRenderFns } from "./tesk.vue?vue&type=template&id=d13b0118&scoped=true"
import script from "./tesk.vue?vue&type=script&lang=js"
export * from "./tesk.vue?vue&type=script&lang=js"
import style0 from "./tesk.vue?vue&type=style&index=0&id=d13b0118&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d13b0118",
  null
  
)

export default component.exports